import { render, staticRenderFns } from "./DashboardView.vue?vue&type=template&id=1e9f1be8"
import script from "./DashboardView.vue?vue&type=script&lang=ts"
export * from "./DashboardView.vue?vue&type=script&lang=ts"
import style0 from "./DashboardView.vue?vue&type=style&index=0&id=1e9f1be8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports